import { render, staticRenderFns } from "./MediaCarousel.vue?vue&type=template&id=0a48b042"
import script from "./MediaCarousel.vue?vue&type=script&lang=js"
export * from "./MediaCarousel.vue?vue&type=script&lang=js"
import style0 from "./MediaCarousel.vue?vue&type=style&index=0&id=0a48b042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports